<template>
    <b-container>
        <Breadcrumbs crumbString="Creative Services"></Breadcrumbs>
        <b-row>
            <b-col class="col-12 col-md-4 col-lg-4">
                <h2>{{ title }}</h2>
                <div>
                    enviroSIGNS maintains a broad creative talent base. Our services include:
                    <ul>
                        <li><router-link :to="{ name: 'content-development' }">Content Development</router-link></li>
                        <li><router-link :to="{ name: 'graphic-design' }">Graphic Design</router-link></li>
                        <li><router-link :to="{ name: 'illustration' }">Illustration</router-link></li>
                    </ul>
                    The Creative Process
                    <p class="indent-p">We understand the underlying psychology associated with interpretive communication.</p>
                    <p class="indent-p">We move projects through the development process, providing reviews at appropriate check points.
                        The goal is no surprises at the end of the project.
                    </p>
                </div>
            </b-col>
            <b-col class="col-12 col-md-8 col-lg-8">
                <b-container class="pods-container">
                    <b-row>
                        <b-col class="col-12 col-md-6 col-lg-6">
                            <b-row>
                                <b-col class="col-12 col-md-12 col-lg-12 image-pod">
                                  <router-link :to="{ name: 'content-development' }">
                                    <div class="img creative-services-img-half-height"
                                         v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/creative-services/interpretive-content-development.jpg') + ')'}"></div>
                                    <span>Content Development</span>
                              </router-link>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col class="col-12 col-md-12 col-lg-12 image-pod">
                                  <router-link :to="{ name: 'graphic-design' }">
                                    <div class="img creative-services-img-half-height"
                                         v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/creative-services/interpretive-graphic-design.jpg') + ')'}"></div>
                                    <span>Graphic Design</span>

                                  </router-link>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col class="col-12 col-md-6 col-lg-6 image-pod">
                          <router-link :to="{ name: 'illustration' }">
                            <div class="img creative-services-img-full-height"
                                 v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/creative-services/interpretive-illustration.jpg') + ')'}"></div>
                            <span>Illustration</span>
                          </router-link>
                        </b-col>
                    </b-row>
                </b-container>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
  import Breadcrumbs from '../Breadcrumbs.vue'

  export default {
    components: {
      Breadcrumbs
    },

    data () {
      return {
        title: 'Creative Services'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/CreativeServices.vue